import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class ViewLead extends Component {

    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
                hideScriptIgnore: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };
        this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchLeadDetails()
                this.setState({ disabled: false })
            }
        }];

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteManageTemplate(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];
        this.state = {
            data: [],
            editImageSrc: './assets/images/edit.svg',
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            contentEditable: "false",
            editedId: '-1',
            leadId: null,
            showTransferLeadsPopUp: false,
            newSalesExecId: null,
            newSalesExecEmailId: null,
            teamMembers: []

        }
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";



    }
    componentDidMount() {
        var leadController = this;

        setTimeout(() => {
            leadController.fetchLeadDetails();
            leadController.fetchTeamDataApi();
            leadController.fetchSupportTeamDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            window.location.href = '/sales-desk/projectmgmt/settings';
            leadController.fetchTeamDataApi();
            leadController.fetchSupportTeamDataApi();
        });
    }



    fetchLeadDetails = () => {

        var leadController = this;
        $.ajax({
            url: "/salesdesk-api/lead-details",
            async: false,
            method: 'POST',
            data: {
                salesExecutiveId: this.props.location.state.userId,
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    leadController.state.data = res.result;
                    leadController.state.showTransferLeadsPopUp = false;
                    leadController.setState(leadController.state);
                } else {
                    leadController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }
    validateCells(value) {
        if ((value == "")) {
            this.notifyEmptyTagKeyFields();
            return false;
        }
        else {
            return true;
        }
    }
    notifyEmptyTagKeyFields() {
        toast(<b >Please change the tag field</b>, {
            position: "bottom-center",
            color: "#007aff"
        });
    }
    updateLeadApi(props, e) {
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.contactNumber = document.getElementById("contactNumber" + props.index).innerText.trim();
        props.original.email = document.getElementById("email" + props.index).innerText.trim();
        props.original.title = document.getElementById("title" + props.index).innerText.trim();
        props.original.companyName = document.getElementById("companyName" + props.index).innerText.trim();



        var validateResult = this.validateCells(props.original.code)
        if (validateResult == true) {

            var updatedData = {
                id: props.original.id,
                name: props.original.name,
                contactNumber: props.original.contactNumber,
                email: props.original.email,
                title: props.original.title,
                companyName: props.original.companyName
            };
            var updatedDataController = this
            $.ajax({
                url: "/salesdesk-api/update-lead-details",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',

                },
                data: JSON.stringify(updatedData),
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchLeadDetails();
                    } else {
                        updatedDataController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }


            })
        }
    }
    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    deleteManageTemplate = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            $.ajax({
                url: "/salesdesk-api/delete-lead-detail",
                async: false,
                method: 'POST',
                data: {
                    projectId: localStorage.getItem('currentProjectId'),
                    contactNumber: props.contactNumber,
                    id: props.id
                },
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(props.id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(props.id, 1);
        }
        deleteConstructorVariables.fetchLeadDetails();


    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            contactNumber="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }
    goBackOfLeads = () => {
        window.location.href = '/sales-desk/projectmgmt/settings';

    }

    showTransferLeads = (props, e) => {

        var showLeadsController = this;
        showLeadsController.state.showTransferLeadsPopUp = true;
        showLeadsController.state.leadId = props.original.id;
        showLeadsController.setState(showLeadsController);
    }

    closeTransferLeadsPopUp = () => {
        this.setState({ showTransferLeadsPopUp: false })
    }

    transferLeadApi = (props, e) => {
        var transferLeadsController = this;

        if (transferLeadsController.state.newSalesExecId != null) {

            $.ajax({
                url: "/salesdesk-api/transfer-individual-lead",
                async: false,
                method: 'POST',
                data: {
                    projectId: localStorage.getItem('currentProjectId'),
                    leadId: transferLeadsController.state.leadId,
                    newSalesExecId: transferLeadsController.state.newSalesExecId,
                    newSalesExecEmailId: transferLeadsController.state.newSalesExecEmailId
                },
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

                success: function (res) {
                    if (res.success === true) {
                        transferLeadsController.fetchLeadDetails();
                        transferLeadsController.notifyTransferStarted();

                    } else {
                        transferLeadsController.setState({ showTransferLeadsPopUp: false });
                        // transferLeadsController.notifyNoLeads();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }

            });
        } else {
            transferLeadsController.notifyWarning("Please select a sales executive");
        }
    }

    notifyTransferStarted() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Leads transfer started</b>, {
            position: "top-center",
        });
    }

    notifyWarning(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }


    fetchTeamDataApi = (projectId) => {
        var teamController = this;
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        $.ajax({
            url: "/api/project-membership-dev-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

            success: function (res) {
                if (res.success === true) {
                    teamController.state.teamMembers = res.result;
                    teamController.setState(teamController.state);
                } else {
                    teamController.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    fetchSupportTeamDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var teamController = this;
        $.ajax({
            url: "/api/project-membership-support-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                teamController.state.successResp = true;

                if (res.success === true) {
                    var responseData = res.result;
                    var adminTeamMembers = teamController.state.teamMembers;
                    Array.prototype.push.apply(responseData, adminTeamMembers);
                    teamController.state.teamMembers = responseData;
                    teamController.setState(teamController);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    notifyFailToCreate() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onChecked = (e) => {
        var onCheckedController = this;

        onCheckedController.setState({
            newSalesExecId: e.currentTarget.name,
            newSalesExecEmailId: e.currentTarget.value,
        });
    }

    render() {

        const { data } = this.state
        this.dataColumn = [
            {
                Header: <b>Name</b>,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div name="name">
                            <div className="textarea"
                                style={{
                                    background: 'white', height: '5%',
                                    resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                    border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                                }}
                                id={"name" + props.index}
                                class="form-control"
                                rows="1"
                                contentEditable={!((props.original.id == "") ? false :
                                    props.original.id != this.state.editedId) ? "plaintext-only" : false}
                            >
                                {props.original.name}
                            </div>
                        </div>
                    )
                },
            },

            {
                Header: () => <b>Email</b>,
                accessor: 'email',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="email">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"email" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.email}
                        </div>
                    </div>
                )
            }, {
                Header: () => <b>Phone Number</b>,
                accessor: 'contactNumber',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="contactNumber">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"contactNumber" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.contactNumber}
                        </div>
                    </div>
                )
            },
            {
                Header: () => <b>Title</b>,
                accessor: 'title',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="title">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"title" + props.index}
                            class="form-control"
                            rows="1"

                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.title}
                        </div>
                    </div>
                )
            },
            {
                Header: () => <b>Organization</b>,
                accessor: 'companyName',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="companyName">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"companyName" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.companyName}
                        </div>
                    </div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                filterable: false,
                flexGrow: 1,
                sortable: false,
                Cell: props => (
                    <div id="action">

                        <button className='btn navyblue-btn' style={{ height: '2vw', width: '8vw', marginBottom: '0.8vw' }}
                            onClick={e => this.showTransferLeads(props, e)}>Transfer Lead</button>

                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px' }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginBottom: '-0.3vw', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', height: '1.7vw' }}
                                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ? this.updateLeadApi(props, e) : (props.original.id == this.state.editedId) ?
                                        this.updateLeadApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginBottom: '-0.3vw', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', height: '1.7vw' }}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchLeadDetails() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original
                                    })} /></button>
                    </div>)
            },
        ]

        this.modalColumn = [
            {
                Header: () => <b>Select the Sales Executive to transfer</b>,
                accessor: 'userEmail',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="userEmail">
                        <div className="textarea"
                            style={{
                                background: 'white', /*userSelect: 'none',*/ height: '5%', overflowY: 'auto',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"userEmail" + props.index}
                            class="form-control"
                            rows="1"
                            suppressContentEditableWarning
                            contentEditable="false"
                        >
                            <div className="col-sm-2" >
                                <input
                                    type="radio"
                                    name={props.original.userId}
                                    value={props.original.userEmail}
                                    checked={this.state.newSalesExecEmailId === props.original.userEmail}
                                    onChange={this.onChecked}
                                    style={{ marginLeft: '2vw', height: '1vw', width: '2vw' }}
                                />
                            </div>
                            <div className='col-sm-4' style={{ fontSize: '1vw' }}>
                                {props.original.userEmail}
                            </div>
                        </div>
                    </div>
                )
            }
        ]


        return (
            <div>
                <div style={{ background: "#F9F9FB" }}
                >
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    {/*links for css files used for popup */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper">
                        <div className="row" style={{ marginLeft: "2px", marginTop: '29px' }}>
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackOfLeads}
                                />
                            </div>
                            <div className="col-sm-5" >
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '35px' }}>
                                    {this.props.location.state.userName}'s Lead
                                </h6>
                            </div>

                        </div>

                        <div className="email">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={data}
                                                columns={this.dataColumn}
                                                defaultPageSize={5}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                            // page={this.state.pageNum}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />


                                    </div>
                                </div>
                            </div>
                            {/*Dialog Component For Deletion Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete the Lead detail?
                                Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
                        </div>
                    </div>
                </div>

                <div className="wrapper">
                    <div className="modal" style={{ display: this.state.showTransferLeadsPopUp ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-account-modal">
                            <div className="modal-content" style={{ height: "auto", width: "750px" }}>
                                <div className="modal-header noBorder" style={{ height: '1px' }}>
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeTransferLeadsPopUp}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ height: '500px' }}>

                                    <ReactTable
                                        data={this.state.teamMembers}
                                        columns={this.modalColumn}
                                        showPagination={false}
                                        style={{ height: '400px' }}
                                    />
                                    <div className="modal-footer noBorder">
                                        <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.transferLeadApi}>Transfer</button>
                                        <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.closeTransferLeadsPopUp}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>

        )
    }


}

export default ViewLead;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/ViewLead.js